import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function timesheet({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      stroke="black"
      className={className}
    >
      <circle fill="none" cx="12" cy="12" r="9" strokeWidth="2" />
      <path
        fill="none"
        strokeLinecap="round"
        strokeWidth="2"
        d="M16.5 12h-4.25a.25.25 0 01-.25-.25V8.5"
      />
    </svg>
  );
}

export default timesheet;
